import MixtilesDialog from '../../components/MixtilesDialog/MixtilesDialog'
import BasicDialogContent from '../../components/MixtilesDialog/BasicDialogContent/BasicDialogContent'
import { translateManager as t } from '../../services/TranslateManager'
import BasicDialogButton from '../../components/MixtilesDialog/BasicDialogButton/BasicDialogButton'

type CompleteOrderErrorDialogProps = {
  show: boolean
  onDismiss: () => void
  onTryAgain: () => void
  talkToUsPressed: () => void
  errorTitle: string
  errorText: string
  dismissOnly: boolean
}

function CompleteOrderErrorDialog(props: CompleteOrderErrorDialogProps) {
  const buttons = props.dismissOnly
    ? [
        {
          text: t.get('general.ok'),
          action: props.onDismiss,
          testId: 'complete-order-error-ok-button',
        },
      ]
    : [
        {
          text: t.get('general.try_again'),
          action: props.onTryAgain,
          testId: 'complete-order-error-try-again-button',
        },
        {
          text: t.get('general.talk_to_us'),
          action: props.talkToUsPressed,
          testId: 'complete-order-error-talk-to-us-button',
        },
      ]

  return (
    <MixtilesDialog
      open={props.show}
      fullScreen={false}
      onDismiss={props.onDismiss}
      transition="slide"
      closeButtonOnDialog={!props.dismissOnly}
    >
      <BasicDialogContent
        icon={props.dismissOnly ? undefined : 'exclamation'}
        title={t.get(props.errorTitle)}
        text={t.get(props.errorText)}
        testId="complete-order-error-dialog"
      />
      {buttons.map(({ text, action, testId }) => (
        <BasicDialogButton action={action} key={testId} testId={testId}>
          {text}
        </BasicDialogButton>
      ))}
    </MixtilesDialog>
  )
}

export default CompleteOrderErrorDialog
